import { LoadingButton } from "@mui/lab";
import { Box, Button, Divider, Link, Stack, Typography } from "@mui/material";
import { lazy, Suspense, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Password from "src/components/Password";
import ChoosePlan from "src/components/choose-plan";
import FormProvider from "src/components/hook-form/FormProvider";
import RHFTextField from "src/components/hook-form/RHFTextField";
import Translate from "src/components/translate";
import { PATH_AUTH } from "src/routes/paths";
import AuthHelper from "./components/authHelper";
import EnterOtp from "./components/enter-otp";
import ErrorBanner from "./components/error-banner";
import useLogin from "./hooks/use-login";
import { GOTO_HOME } from "src/config";

const GoogleOAuthButton = lazy(() =>
  import("src/pages/auth/components/google-login"),
);

const LoginForm = () => {
  const { onSubmit, methods } = useLogin();
  const [showGoogleLogin, setShowGoogleLogin] = useState(false);

  const {
    watch,
    formState: { isSubmitting },
  } = methods;

  const data = watch();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowGoogleLogin(true);
    }, 1200);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack spacing={1.5} mb={1.5}>
          {/* <AuthHelper /> */}
          <ErrorBanner />
        </Stack>

        <Stack spacing={2}>
          <RHFTextField
            name="email"
            label="register.email"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "#F8F9FA",
              },
            }}
          />
          <Password
            name="password"
            label="register.password"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "#F8F9FA",
              },
            }}
          />
          <ChoosePlan />
        </Stack>

        <Box sx={{ textAlign: "right", mt: 1, mb: 2.5 }}>
          <Link
            component={RouterLink}
            variant="body2"
            sx={{
              color: "primary.main",
              textDecoration: "none",
              fontSize: "13px",
            }}
            to={PATH_AUTH.resetPassword}
          >
            <Translate>register.forgot</Translate>
          </Link>
        </Box>

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          name="login"
          sx={{
            borderRadius: "10px",
            fontWeight: 700,
            fontSize: "15px",
            backgroundColor: "primary.main",
            color: "#fff",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "primary.dark",
              boxShadow: "0 8px 24px rgba(184, 149, 47, 0.3)",
              transform: "translateY(-1px)",
            },
          }}
        >
          <Translate>register.login</Translate>
        </LoadingButton>

        {/* {showGoogleLogin && ( */}
        <>
          {/* <Divider sx={{ mt: 2.5 }}>
            <Typography variant="caption" sx={{ color: "text.disabled" }}>
              Or Continue With
            </Typography>
          </Divider> */}
          {/* <Suspense fallback={null}>
            <GoogleOAuthButton
              plan={methods.getValues("plan")}
              buttonLabel="register.google_login"
            />
          </Suspense> */}
        </>
        {/* )} */}
      </FormProvider>

      <EnterOtp data={data} />
    </>
  );
};

export default LoginForm;
